import { createAction } from '@reduxjs/toolkit';

import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

// Login
export const validateResetPasswordCodeRequest = createAction('validateResetPasswordCodeRequest');
export const validateResetPasswordCodeSuccess = createAction('validateResetPasswordCodeSuccess');
export const validateResetPasswordCodeFailure = createAction<string>(
    'validateResetPasswordCodeFailure',
);

export const validateResetPasswordCode = (code: string) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(validateResetPasswordCodeRequest());

    try {
        await api.get('admin/auth/reset-password', { code });
        dispatch(validateResetPasswordCodeSuccess());
    } catch (e) {
        handleApiErrors(dispatch, validateResetPasswordCodeFailure, e);
    }
};
